import { SectionContainer } from '@/pages/shared-components/SectionContainer'
import { IconWarningOutline } from '@icons/IconWarningOutline'
import { Badge } from '@/components/shadcn/badge'
import { useRestClient } from '@/contexts/QueryProvider'
import { useCurrentProject } from '../useCurrentProject'

export function ProjectDatabricksStatusSection() {
  const { projectId } = useCurrentProject()
  const { getDatabricksApiGetDatabricksProjectIntegrationStatus } = useRestClient()

  const { data: integration, isLoading } = getDatabricksApiGetDatabricksProjectIntegrationStatus.useQuery({
    query: { projectId },
  })

  if (isLoading) {
    return (
      <SectionContainer title="Integration status">
        <div className="text-sm text-muted-foreground">Checking integration status...</div>
      </SectionContainer>
    )
  }

  return (
    <SectionContainer title="Integration status">
      {integration?.message ? (
        <div className="flex gap-5 rounded-lg border-l-8 border-yellow-400 bg-yellow-50 p-4 text-yellow-700">
          <IconWarningOutline className="size-7 shrink-0" />
          <div className="whitespace-pre-wrap font-light italic">{integration.message}</div>
        </div>
      ) : (
        <Badge variant="success">Ready</Badge>
      )}
    </SectionContainer>
  )
}
